import React from "react";
import { useNavigate } from "react-router";
import { MotionConfig } from "motion/react";
import { useAuth } from "../context/AuthContext";
import { LandingNav } from "../features/landing/components/LandingNav";
import { HeroSection } from "../features/landing/components/HeroSection";
import { FeatureShowcase } from "../features/landing/components/showcase/FeatureShowcase";
import { HowItWorksStory } from "../features/landing/components/how-it-works/HowItWorksStory";
import { PricingSection } from "../features/landing/components/pricing/PricingSection";
import { CtaSection } from "../features/landing/components/CtaSection";
import { LandingFooter } from "../features/landing/components/LandingFooter";

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleGetStarted = () => {
    if (isAuthenticated) {
      navigate("/topics");
    } else {
      navigate("/register");
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    // "user" honours prefers-reduced-motion for every animation on the page.
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen bg-white">
        <LandingNav
          isAuthenticated={isAuthenticated}
          onLogin={handleLogin}
          onGetStarted={handleGetStarted}
        />
        <HeroSection onGetStarted={handleGetStarted} />
        <FeatureShowcase />
        <HowItWorksStory />
        <PricingSection onGetStarted={handleGetStarted} />
        <CtaSection onGetStarted={handleGetStarted} />
        <LandingFooter />
      </div>
    </MotionConfig>
  );
};

export default Landing;
